import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import HttpStatus from '../../../model/enums/httpStatus';
import { ProgramSimulationExample } from '../../../model/program';
import programApi from '../../../services/api/programApi';
import { ErrorUtils } from '../../../shared/error/error-utils';
import { markError } from '../../application/error/actions';
import { programSimulationExampleError, programSimulationExampleRequest, programSimulationExampleSuccess } from './actions';
import { ProgramSimulationExampleActionTypes } from './types';


function* handleProgramSimulationExampleRequest(action: ReturnType<typeof programSimulationExampleRequest>) {
  try {
    const result: AxiosResponse<ProgramSimulationExample> = yield call(programApi.getSimulationExample, action.payload);
    if (result.status !== HttpStatus.OK) {
      const mapped = ErrorUtils.mapGiroApiError(result);
      yield put(markError(mapped));
      yield put(programSimulationExampleError(mapped));
      return;
    }
    yield put(programSimulationExampleSuccess(result.data));
  } catch (error) {
    const mapped = ErrorUtils.mapLocalError(error);
    yield put(markError(mapped));
    yield put(programSimulationExampleError(mapped));
  }
}

function* watchProgramSimulationExampleRequest() {
  yield takeEvery(ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_REQUEST, handleProgramSimulationExampleRequest);
}



function* programSimulationExampleSaga() {
  yield all([
    fork(watchProgramSimulationExampleRequest),
  ]);
}

export default programSimulationExampleSaga;
